import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, saveSessionToken } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { t, useLang } from "../lib/i18n";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  useLang();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const error = params.get("error");

    if (error || !code) {
      navigate("/");
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/callback", { code });
        saveSessionToken(data.session_token);
        setUser(data.user);

        const redirectTo = localStorage.getItem("post_login_redirect");
        localStorage.removeItem("post_login_redirect");

        // If the redirect is an invite link, join the room directly and go
        // straight to the waiting room — avoids an extra JoinRoom round-trip
        // and survives mobile browsers that clear sessionStorage on OAuth redirect.
        if (redirectTo?.startsWith("/join/")) {
          const roomId = redirectTo.slice("/join/".length);
          try {
            await api.post(`/rooms/${roomId}/join`);
            navigate(`/room/${roomId}`, { replace: true });
          } catch {
            // Room might be full or gone — let JoinRoom handle the error screen
            navigate(redirectTo, { replace: true });
          }
          return;
        }

        navigate(redirectTo || "/lobby", { replace: true });
      } catch (e) {
        console.error("Auth callback failed", e);
        navigate("/");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="rami-glass rounded-2xl px-8 py-6 text-slate-200" data-testid="auth-callback-loading">
        {t("common.connecting")}
      </div>
    </div>
  );
}
